// Copyright (c) 2016 Deere & Company

import {
    resetCriteria,
    updatePinsNotRegisteredCriteria
} from './criteria';
import {selectAllDealersOnLoad, selectAllPinsNotRegisteredDealers, selectPinsNotRegisteredDealer} from './select-dealer';
import {createPinsNotRegisteredReport} from './create-report';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createPinsNotRegisteredReport,
    resetCriteria,
    selectAllDealersOnLoad,
    selectAllPinsNotRegisteredDealers,
    selectPinsNotRegisteredDealer,
    updatePinsNotRegisteredCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/action-creators/index.js